/* eslint-disable no-console */
import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import SubscriptionS from '../restapi/subscriptionService';
import { RoutingS } from '../RoutingS';
import { AuthContext } from './AuthContext';

declare global {
  interface Window {
    hsConversationsSettings: any;
    hsConversationsOnReady: any;
    HubSpotConversations: any;
  }
}

interface Props {
  openWidget: () => void;
}

export const HubspotContext = createContext({} as Props);

export const HubspotProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { jwtClaims } = useContext(AuthContext);
  const { supportLogin, email } = jwtClaims;
  const [loaded, setLoaded] = useState(false);

  const idenfity = (token: string | null) => {
    console.info(`Identiying: ${email}, ${token}`);
    if (token) {
      window.hsConversationsSettings = {
        identificationEmail: email,
        identificationToken: token,
      };
    }
    const status = window.HubSpotConversations.widget.status();
    if (status.loaded) {
      window.HubSpotConversations.widget.refresh();
    } else {
      window.HubSpotConversations.widget.load();
    }
  };

  const hideWidgetIcon = () => {
    const widgetContainer = document.querySelector('#hubspot-messages-iframe-container') as HTMLDivElement | null;
    if (widgetContainer) {
      widgetContainer.style.marginBottom = '-80px';
    }
  };

  const showWidgetIcon = () => {
    const widgetContainer = document.querySelector('#hubspot-messages-iframe-container') as HTMLDivElement | null;
    if (widgetContainer) {
      widgetContainer.style.marginBottom = '0px';
    }
  };

  useEffect(() => {
    if (!supportLogin && loaded) {
      idenfity(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supportLogin, email, loaded]);

  // Load JS file
  useEffect(() => {
    console.info('Loading hubspot js');
    window.hsConversationsSettings = {
      loadImmediately: false,
    };
    window.hsConversationsOnReady = [
      () => {
        console.info('HubSpot Conversations loaded');
        setLoaded(true);
        if (window.innerWidth < 768) {
          if (RoutingS.isUnprotectedRoute(window.location.pathname)) {
            setTimeout(showWidgetIcon, 1000);
          } else {
            window.HubSpotConversations.on('widgetClosed', hideWidgetIcon);
          }
        }
      },
    ];
    const script = document.createElement('script');
    script.id = 'hs-script-loader';
    script.src = 'https://js-eu1.hs-scripts.com/25589471.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
      window.hsConversationsOnReady = [];
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Open the HubSpot chat widget.
   */
  const openWidget = () => {
    const widgetContainer = document.querySelector('#hubspot-messages-iframe-container') as HTMLDivElement | null;
    if (widgetContainer) {
      widgetContainer.style.marginBottom = '0';
      window.HubSpotConversations.widget.open();
    }
  };

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <HubspotContext.Provider value={{ openWidget }}>{children} </HubspotContext.Provider>;
};

export const useConversationsWidget = () => {
  const { openWidget } = useContext(HubspotContext);
  return { openWidget };
};
